module.exports = __webpack_public_path__ + "img/generated-1772425775040.b48584c9.png";